import React from 'react';
import { PlannerTaskInfo } from './types';

interface ScheduleUpcomingProps {
    groups: Array<{ key: string; label: string; tasks: PlannerTaskInfo[] }>;
    renderTask: (taskInfo: PlannerTaskInfo) => React.ReactNode;
}

export const ScheduleUpcoming: React.FC<ScheduleUpcomingProps> = ({ groups, renderTask }) => {
    const visibleGroups = groups.filter(({ tasks }) => tasks.length > 0);
    return (
        <div className="schedule-upcoming-groups">
            {visibleGroups.map(({ key, label, tasks }) => (
                <section className="schedule-upcoming-group" key={key}>
                    <div className="schedule-upcoming-label">
                        <span>{label}</span>
                        <span>{tasks.length}</span>
                    </div>
                    <div className="schedule-tasks">
                        {tasks.map((taskInfo) => renderTask(taskInfo))}
                    </div>
                </section>
            ))}
        </div>
    );
};
